import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type PDF = {
  clicked: boolean;
  showReport: boolean;
};

const pdfState: PDF = {
  clicked: false,
  showReport: false,
};

export const pdfSlice = createSlice({
  name: 'pdfSlice',
  initialState: pdfState,
  reducers: {
    clickedPDF: (state, action: PayloadAction<PDF>) => {
      state.clicked = action.payload.clicked;
    },
    setPdfClicked: (state, action: PayloadAction<boolean>) => {
      state.clicked = action.payload;
    },
    setShowReport: (state, action: PayloadAction<boolean>) => {
      state.showReport = action.payload;
    },
  },
});

export const { clickedPDF, setPdfClicked, setShowReport } = pdfSlice.actions;
